<!-- eslint-disable -->
<template>
    <main>
      <section class="legal-section">
          <button @click="$router.go(-1)" class="modal-close"><span></span><span></span><span></span></button>
        <div class="grid-container">
          <div class="grid-row">
            <div class="col-12">
                <h1>Impressum</h1>
                <h3>Rechtsanwalt Alexander Biernacki</h3>
                <p>Kanzlei- und Zustellanschrift</p>
                <p>Domplatz 12a<br>
                06618 Naumburg</p>
                <p>Tel. 03445/797900<br>
                Fax. 03445/7979001</p>
                <p>Zuständige Rechtsanwaltskammer:</p>
                <p>Rechtsanwaltskammer Sachsen-Anhalt</p>
                <p>Gerhart-Hauptmann-Str. 5</p>
                <p>39108 Magdeburg</p>
                <p>USt-IdNr.: DE 265401917</p>
                <p>Vermögensschadenhaftpflichtversicherung nach § 51 BRAO: R+V Versicherung AG, Raiffeisenplatz 1, 65189 Wiesbaden</p>
                <p>Der Versicherungsschutz bezieht sich nicht auf Haftpflichtansprüche aus Tätigkeiten a) über in anderen Staaten eingerichtete oder unterhaltene Kanzleien oder Büros, b) im Zusammenhang mit der Beratung und Beschäftigung mit außereuropäischem Recht oder c) des Rechtsanwalts vor außereuropäischen Gerichten.</p>
                <p>Der räumliche Geltungsbereich bezieht sich auf die Mitgliedsländer der EU.</p>
                <p>Rechtsanwältinnen und Rechtsanwälte sind aufgrund der Bundesrechtsanwaltsordnung verpflichtet, eine Berufshaftpflichtversicherung mit einer Mindestversicherungssumme von 250.000 Euro zu unterhalten. Die Einzelheiten ergeben sich aus § 51 BRAO.</p>
                <p>Rechtsanwalt Biernacki ist in Deutschland zugelassen. Die Berufsbezeichnung Rechtsanwalt wurde ihm in der Bundesrepublik Deutschland verliehen.</p>
                <p>Es gelten die berufsständischen Regelungen der Bundesrechtsanwaltsordnung (BRAO), der Berufsordnung für Rechtsanwälte (BORA), die Fachanwaltsord-nung (FAO), die Bundesgebührenordnung für Rechtsanwälte (BRAGO), das Rechtsanwaltsvergütungsgesetzes (RVG), die Fachanwaltsordnung, die Berufs-regeln der Rechtsanwälte in der Europäischen Union und das Gesetz über die Tätigkeit europäischer Rechtsanwälte in Deutschland (EURAG)</p>
                <p>Diese Vorschriften finden Sie im Wortlaut unter:<br>
                http://www.brak.de/seiten/06.php</p>
            </div>
          </div>
        </div>
      </section>
    </main>
</template>
<script>
export default {
  name: 'Imprint'
};
</script>
